<template>
  <div id="app">
    <link rel="stylesheet" :href="dataCdn"/>
    <div class="row text-left">
      <div class="col-12 col-md-6 d-block d-lg-none">
        <div class="form-group">
          <select class="custom-select" @change="scrollToCategory($event.target.value, true)">
            <option v-for="(value, key) in guidebooks" :key="'select' + key" :value="key">
              {{ value[0].section }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-lg-8">
        <ul class="list-group rounded bg-white">
          <template v-for="(value, key) in guidebooks">
            <li class="list-group-item" v-bind:key="key">
              <h4 class="mb-0" :id="key">{{ value[0].section }}</h4>
            </li>
            <li class="list-group-item" v-for="(guide, i) in value" :key="'guide' + key + i">
              <i class="fas fa-arrow-right mr-2"></i>
              <a :href="getGuideUrl(guide.category, key, guide.link)"
                 @click.prevent="openGuidePopup(guide.category, key, guide.link, guide.title)"
              >{{ guide.title }}</a>
            </li>
          </template>
        </ul>
      </div>
      <div class="col-4 d-none d-lg-block">
        <ul class="list-group rounded bg-white sticky-categories">
          <li class="list-group-item bg-secondary">
            {{ categoryLabel }}
          </li>
          <li class="list-group-item" v-for="(value, key) in guidebooks" :key="'list' + key">
            <i class="far fa-bookmark text-black"></i>
            <a @click="scrollToCategory(key)" :href="'#' + key">{{ value[0].section }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: function () {
    return {
      initialData: null,
      guidebooks: [],
      platformUrl: null,
      categoryLabel: '',
      language: 'it'
    }
  },
  props: {
    dataInit: String,
    dataCdn: String,
  },
  created: function () {
    this.initialData = JSON.parse(atob(this.dataInit))
    this.platformUrl = this.initialData.platformUrl
    this.guidebooks = this.initialData.guidebooks
    this.categoryLabel = this.initialData.categoryLabel
    this.language = this.initialData.language
  },
  mounted: function () {
    this.$nextTick(function () {
      if (location.hash) {
        this.scrollToCategory(location.hash.slice(1))
      }
    })
  },
  methods: {
    scrollToCategory: function (selector, setUrl = false) {
      this.$el.querySelector("#" + selector).scrollIntoView({
        behavior: "smooth"
      })
      if (setUrl)
        window.location.href = location.origin + location.pathname + '#' + selector
    },
    getGuideUrl: function (section, category, link) {
      let guidebookPath = this.language + '/' + section + '/' + category + '/' + link
      return location.origin + location.pathname + '/' + btoa(guidebookPath)
    },
    openGuidePopup: function (section, category, link, title) {
      window.open(
          this.getGuideUrl(section, category, link),
          title,
          'directories=no, scrollbars=yes, menubar=no, width=950, resizable=yes, toolbar=no, location=no, status=no'
      )
      return false
    }
  }
}
</script>
<style>
.sticky-categories {
  position: -webkit-sticky;
  position: sticky;
  top: 8px;
}
</style>